import { isDniFeatureEnabled } from '@/config/featureFlags';
import type { AddressGuest } from '@/modules/customerData/domain/AddressGuest';
import {
  IdentificationDocumentTypes,
  isDni,
  isRut
} from '@/modules/shared/types/IdentificationDocumentType';
import type { AddressGuestFormValues } from '@/sections/customerData/types/AddressGuestFormValues';

export const addressGuestFormToAddress = (
  addressForm: AddressGuestFormValues
): Omit<AddressGuest, 'id'> => {
  const dniEnabled = isDniFeatureEnabled();

  const {
    'prefix-phone': prefixPhone,
    phone,
    documentType,
    documentID,
    customerRut,
    ...rest
  } = addressForm;

  const phoneWithoutSpaces = phone?.replace(/\s/g, '');
  const effectiveDocumentType =
    dniEnabled && documentType ? documentType : IdentificationDocumentTypes.RUT;

  return {
    ...rest,
    phone: `${prefixPhone}${phoneWithoutSpaces}`,
    documentType: effectiveDocumentType,
    // * For backward compatibility: send documentID with customerRut value when documentType is RUT, or with documentID value when DNI
    documentID:
      dniEnabled && isDni(effectiveDocumentType)
        ? documentID
        : isRut(effectiveDocumentType)
          ? customerRut
          : undefined,
    // * For backward compatibility, always send customerRut when documentType is RUT (Chilean RUT)
    customerRut: isRut(effectiveDocumentType) ? customerRut : undefined
  };
};
